import React, { useState, useEffect } from 'react';
import Events from '../components/Events/Events';
import HeaderAnimation from '../components/Header/HeaderAnimation';
import Name from '../components/Name/Name';
import Gallery from '../components/Gallery/Gallery';
import MobileGallery from '../components/MobileGallery/Gallery';
import Team from '../components/Team/Team';
import Coordinator from '../components/Coordinators/Coordinators';
import FAQ from '../components/FAQ/FAQ';
import Footer from '../components/Footer/Footer';
import Gift from '../components/Gift/Gift';
import './HomePage.css';

const HomePage = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 400);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 500);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
    <>
      <Name />
      <Gift />
      <Events />
      {isMobile?<MobileGallery />:  <Gallery />}
      <Coordinator />
      <FAQ />
      <Footer />
    </>
  );
};

export default HomePage;
